import React, { useState, useContext, useEffect } from "react";
import "../homepage.css"
import "./innercss.css";
import { Form, Link, redirect } from "react-router-dom";
import UserApplication from "../UserContext/UserContext";
import { useParams } from 'react-router-dom'
import { barely, barely_black_bg_img } from "../../../public/LoginImages/importimages";
import { apiurl } from '../../../path';


const BidderRegister = () => {
  let data = useContext(UserApplication)
  const { SetNotification, paymentdata, GetAuctionsList, TenderRegisterHash, TenderPayment, DownloadReciept, setpaymentdata } = data
  const [form, setform] = useState([])
  const [Auction, SetAuction] = useState([])
  const { Auction_ID, Auction_Name } = useParams()
  const [forminf, SetForminf] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    Account_HolderName: "",
    BranchName: ""
  })
  console.log(forminf.IFSC_CODE);

  const [recieptview, showrecieptview] = useState(true)
  const [isGSTValid, setIsGSTValid] = useState(null);
  const [isPANValid, setIsPANValid] = useState(null);
  const [accountnum, setaccountnum] = useState(null);

  const [isIfscValid, setIsIfscValid] = useState(null);

  const validateIfsc = async () => {
    let IFSC_CODE = document.getElementById('IFSC_CODE').value.toUpperCase();
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
      if (response.ok) {
        setIsIfscValid(true);
      } else {
        setIsIfscValid(false);
      }
    } catch (error) {
      setIsIfscValid(false);
      console.error("Error validating IFSC code:", error);
    }
  };


  // const checkGSTandPAN = () => {
  //   try {
  //     let GST_No = document.getElementById('GST_No').value.toUpperCase();
  //     let PAN_No = document.getElementById('PAN_No').value.toUpperCase();

  //     const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
  //     const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

  //     const isGSTValid = gstRegex.test(GST_No);
  //     const isPANValid = panRegex.test(PAN_No);

  //     // const modifiedString = GST_No.slice(2, -3);

  //     setIsGSTValid(isGSTValid);
  //     setIsPANValid(isPANValid);

  //     if (!isGSTValid) {
  //       alert("Invalid GST Number");
  //     }
  //     if (!isPANValid) {
  //       alert("Invalid PAN Number");
  //     }

  //     // if (PAN_No === isPANValid) {
  //     //   setIsPANValid(isPANValid);
  //     // } else {
  //     //   alert('Invalid PAN Number');
  //     //   setIsPANValid(false);
  //     // }

  //     setIsGSTValid(isGSTValid);
  //   } catch (error) {
  //     console.error('Error in checkGSTandPAN:', error);
  //     throw error;
  //   }
  // };

  const checkGSTandPAN = (id, value) => {
    const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
    const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;
  
    if (id === "GST_No") {
      setIsGSTValid(value.trim() === "" ? null : gstRegex.test(value));
    }
  
    if (id === "PAN_No") {
      setIsPANValid(value.trim() === "" ? null : panRegex.test(value));
    }
  };
  

  useEffect(() => {
    try {
      setpaymentdata(null)
      // getdata()
    } catch (error) {
      console.error('Error in useEffect:', error);
      throw error;
    }
  }, [])




  const setdata = (e) => {
    try {
      let check = document.getElementById("checkacnumber").value;
      let acnum = document.getElementById("Account_Number").value;
      if (check === "" || acnum === "") {
        setaccountnum(null);
      } else {
        setaccountnum(check === acnum ? true : false);
      }
      // setaccountnum(check === acnum && check !== "" && acnum !== "" ? true : false);
  
      const { id, value } = e.target;
      let finalValue = value;
  
      // Ensure IFSC_CODE is always uppercase
      if (id === "IFSC_CODE") {
        finalValue = value.toUpperCase();
      }
  
      // Update form state
      SetForminf((prev) => ({ ...prev, [id]: finalValue }));
  
      // Perform validation only for GST_No and PAN_No
      if (id === "GST_No" || id === "PAN_No") {
        checkGSTandPAN(id, finalValue);
      }
    } catch (error) {
      console.error("Error in setdata:", error);
      throw error;
    }
  };
  


  const onSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch(`${apiurl}/vendorregistration/registrationform`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(forminf),
      });
      const data = await response.json();
      console.log(data)
      if (data.message === "Vendor registered successfully") {
        alert(data.message)
        window.location.reload();
      }
      if (data.message === "Vendor already registered") {
        alert(data.message)
        window.location.reload();
      }
    } catch (error) {
      console.error('Error in onSubmit:', error);
      throw error;
    }
  }

  return (
    <div style={{ backgroundImage: `url('${barely_black_bg_img}')`, backgroundSize: 'cover', width: '100vw', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem' }}>


      <div style={{ display: "grid", justifyContent: "center" }}>
        <div className="card-body my-3" style={{ width: "80vw" }}>
          <Form id='form1' onSubmit={(e) => { isPANValid === true && accountnum === true && isIfscValid === true ? onSubmit(e) : alert('incorrect details') }} style={{ backgroundColor: 'rgb(255,255,255,0.8)' }} >
            <hr></hr>
            <h5 className="card-header" style={{ textAlign: "center" }}><b>Vendor Registeration Form</b></h5>
            <hr></hr>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Company Name*:</label>
                <input type="text" id="Bidder_CompanyName" placeholder="Enter your Company Name" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Address*:</label>
                <input type="text" id="Address" placeholder="Enter Address" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
            </div>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>City*:</label>
                <input type="text" id="City" placeholder="Enter City" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Pin Code*:</label>
                <input type="tel" id="PinCode" pattern="\d{6}" minLength="6" maxLength="6" placeholder="Enter Pin Code" className="form-control"
                  onInput={(e) => {
                    let enteredValue = e.target.value;
                    enteredValue = enteredValue.slice(0, 6).replace(/\D/g, '');
                    e.target.value = enteredValue;
                  }}
                  onChange={(e) => { setdata(e) }}
                  required
                />
              </div>
            </div>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>GST Number (capital letters only)*:</label>
                <input type="text" id="GST_No" placeholder="Enter GST No." className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{ }} value={forminf.GST_No || ""} minLength={15} maxLength={15}/>
                {isGSTValid === false  && <b style={{ color: "red" }}>Incorrect GST</b>}
                {isGSTValid === true && <b style={{ color: "green" }}>Correct</b>}
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>PAN Number (capital letters only)*:</label>
                <input type="text" id="PAN_No" placeholder="Enter PAN No." className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{ }}  value={forminf.PAN_No || ""} minLength={10} maxLength={10}/>
                {isPANValid === false && <b style={{ color: "red" }}>Invalid PAN</b>}
                {isPANValid === true && <b style={{ color: "green" }}>Valid</b>}
              </div>
            </div>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Mobile No*:</label>
                <input type="tel" className="form-control" id="Mobile_No" pattern="\d{10}" minLength="10" maxLength="10" placeholder="Enter Mobile No."
                  onInput={(e) => {
                    let enteredValue = e.target.value;
                    enteredValue = enteredValue.slice(0, 10).replace(/\D/g, '');
                    e.target.value = enteredValue;
                  }}
                  onChange={(e) => { setdata(e) }}
                  required
                />
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Email*:</label>
                <input type="email" id="Email" placeholder="Enter Email" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
            </div>

            <hr></hr>
            <h5 style={{ textAlign: "center" }}><b>Bank Details</b></h5>
            <hr></hr>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Bank Name*:</label>
                <input type="text" id="BANK_NAME" placeholder="Enter Bank Name" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Account Holder Name*:</label>
                <input type="text" id="Account_HolderName" placeholder="Enter Account Holder Name" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
            </div>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Account Number*:</label>
                <input type="text" id='checkacnumber' placeholder="Enter Account Number" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label> Confirm Account Number*:</label>
                <input type="text" id="Account_Number" placeholder="Confirm Account Number" className="form-control" required onChange={(e) => { setdata(e) }} />
                {
                  accountnum !== null && (
                    <b style={{ color: accountnum === false ? 'red' : 'green' }}>{accountnum === false ? 'Account number does not match' : 'Matched'}</b>
                  )
                }
              </div>
            </div>
            <div className="bidder_register_form">
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>IFSC Code*:</label>
                <input type="text" id="IFSC_CODE" placeholder="Enter IFSC Code" className="form-control" required onChange={(e) => { setdata(e); validateIfsc() }} style={{ textTransform: 'uppercase' }} />
                {
                  isIfscValid !== null && (
                    <b style={{ color: isIfscValid === false ? 'red' : 'green' }}>{isIfscValid === false ? 'IFSC Code is invalid' : 'IFSC code is valid'}</b>
                  )
                }
              </div>
              <div className="mx-3" style={{ width: "33rem" }}>
                <label>Branch Name*:</label>
                <input type="text" id="BranchName" placeholder="Branch Name" className="form-control" required onChange={(e) => { setdata(e) }} />
              </div>
            </div>

            <div className="bidder_register_form">
              <button className="btn btn-success my-3 mx-5" type="submit" >Submit</button>
              <Link to={'/Dashboard/DownloadReciept/' + forminf.Tender_ID + '/' + forminf.GST_No + '/' + forminf.PAN_No} hidden={recieptview} >Download Reciept</Link>
            </div>
          </Form>
        </div>
      </div>


    </div>

  );
};

export default BidderRegister;
